import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Snackbar,
  Alert,
  IconButton,
  Chip,
  Stack,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ReservationForm = ({ cliente, onClose }) => {
  const [form, setForm] = useState({
    clientId: cliente?.id || '',
    reservationDate: '',
    reservationTime: '',
    paymentMethod: '',
    priceTotal: '',
    services: [] // inicialmente vacío
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddService = () => {
    const trimmed = inputValue.trim();
    if (trimmed && !form.services.includes(trimmed)) {
      setForm({ ...form, services: [...form.services, trimmed] });
      setInputValue('');
    }
  };

  const handleDeleteService = (serviceToDelete) => {
    setForm({
      ...form,
      services: form.services.filter((service) => service !== serviceToDelete)
    });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Validaciones obligatorias
  if (
    !form.reservationDate ||
    !form.reservationTime ||
    !form.paymentMethod ||
    !form.priceTotal ||
    form.services.length === 0
  ) {
    setErrorMessage('Todos los campos son obligatorios y debe haber al menos un servicio.');
    setOpenSnackbar(true);
    return;
  }

  try {
    const response = await fetch('https://softwaregestion-production-b8ad.up.railway.app/api/reservate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([{
        ...form,
        services: form.services.filter((s) => s.trim() !== '')
      }])
    });

    const data = await response.json();

    if (response.ok) {
      alert('Reserva creada con éxito');
      console.log(data);
      onClose();
    } else {
      throw new Error(data.message || 'Error desconocido');
    }
  } catch (error) {
    console.error('Error al enviar reserva:', error);
    setErrorMessage(error.message || 'Error al crear la reserva');
    setOpenSnackbar(true);
  }
};


  return (
    <Paper elevation={0} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Crear Reserva para {cliente.name} {cliente.lastName}
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
        <TextField
          fullWidth
          margin="normal"
          label="Fecha"
          name="reservationDate"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={form.reservationDate}
          onChange={handleChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Hora"
          name="reservationTime"
          type="time"
          InputLabelProps={{ shrink: true }}
          value={form.reservationTime}
          onChange={handleChange}
          required
        />
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
          <TextField
            label="Nuevo servicio"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            variant="outlined"
            size="small"
            required
          />
          <Button
            variant="outlined"
            onClick={handleAddService}
          >
            Añadir
          </Button>
        </Box>

        <Stack direction="row" flexWrap="wrap" gap={1}>
          {form.services.map((service, index) => (
            <Chip
              key={index}
              label={service}
              onDelete={() => handleDeleteService(service)}
              sx={{ backgroundColor: '#e6f0fb' }}
            />
          ))}
        </Stack>
               {/* Campo Select para el método de pago */}
        <FormControl fullWidth margin="normal" required>
          <InputLabel id="payment-method-label">Método de pago</InputLabel>
          <Select
            labelId="payment-method-label"
            id="paymentMethod"
            name="paymentMethod"
            value={form.paymentMethod}
            onChange={handleChange}
            label="Método de pago"
            required
          >
            <MenuItem value="tarjetas">Tarjeta de Crédito y/o Débito</MenuItem>
            <MenuItem value="transferencia">Transferencia</MenuItem>
            <MenuItem value="efectivo">Efectivo</MenuItem>
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Precio total"
          name="priceTotal"
          type="number"
          value={form.priceTotal}
          onChange={handleChange}
          required
        />

 

   

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button variant="contained" color="primary" type="submit">
            Guardar reserva
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default ReservationForm;
